import $ from 'jquery';

const responsive = {
  lastScreen : {
    0 : {
      'value' : {
        'height' : null,
        'width' : null
      },
      'name' : {
        'height' : null,
        'width' : null
      }
    }
  },
  screens : {
    'xl'  : {
      'name'      : 'superLgDesktop',
      'maxWidth'  : null,
      'minWidth'  : 1200 + 1
    },
    'lg'  : {
      'name'      : 'lgDesktop',
      'maxWidth'  : 1200,
      'minWidth'  : 992 + 1
    },
    'md'  : {
      'name'      : 'desktop',
      'maxWidth'  : 992,
      'minWidth'  : 768 + 1
    },
    'sm'  : {
      'name'      : 'tablet',
      'maxWidth'  : 768,
      'minWidth'  : 576 + 1
    },
    'xs' : {
      'name'      : 'phone',
      'maxWidth'  : 576,
      'minWidth'  : 0
    },
  },
  getCurrentScreen : {
    value : {
      height : () => {
        return $(window).outerHeight();
      },
      width : () => {
        return $(window).outerWidth();
      }
    },
    name : {
      accordingToWidth : () => {
        let screenWidth = responsive.getCurrentScreen.value.width();
        let currentScreenName = '';

        $.each(responsive.screens, (key, value) => {
          if (
            (screenWidth <= value['maxWidth']  || !value['maxWidth'])
            && screenWidth >= value['minWidth']
          ) {
            currentScreenName = key;
            return false;
          }
        });

        return currentScreenName;
      }
    }
  },
  changeScreen : {
    value : {
      accordingToHeight : (lastScreenId) => {
        lastScreenId = lastScreenId || 0;
        let currentScreenHeight = responsive.getCurrentScreen.value.height();

        if (
          !responsive.lastScreen[lastScreenId]
          || !responsive.lastScreen[lastScreenId].value.height
        ) {
          responsive.lastScreen[lastScreenId] = responsive.lastScreen[lastScreenId] || {};
          responsive.lastScreen[lastScreenId].value = responsive.lastScreen[lastScreenId].value || {};
          responsive.lastScreen[lastScreenId].value.height = currentScreenHeight;

          return false;
        }

        let isDifferentScreen = responsive.lastScreen[lastScreenId].value.height != currentScreenHeight;
        responsive.lastScreen[lastScreenId].value.height = currentScreenHeight;

        return isDifferentScreen;
      },
      accordingToWidth : (lastScreenId) => {
        lastScreenId = lastScreenId || 0;
        let currentScreenWidth = responsive.getCurrentScreen.value.width();

        if (
          !responsive.lastScreen[lastScreenId]
          || !responsive.lastScreen[lastScreenId].value.width
        ) {
          responsive.lastScreen[lastScreenId] = responsive.lastScreen[lastScreenId] || {};
          responsive.lastScreen[lastScreenId].value = responsive.lastScreen[lastScreenId].value || {};
          responsive.lastScreen[lastScreenId].value.width = currentScreenWidth;

          return false;
        }

        let isDifferentScreen = responsive.lastScreen[lastScreenId].value.width != currentScreenWidth;
        responsive.lastScreen[lastScreenId].value.width = currentScreenWidth;

        return isDifferentScreen;
      }
    },
    name : {
      accordingToWidth : (lastScreenId) => {
        lastScreenId = lastScreenId || 0;
        let currentScreenName = responsive.getCurrentScreen.name.accordingToWidth();

        if (
          !responsive.lastScreen[lastScreenId]
          || !responsive.lastScreen[lastScreenId].name.width
        ) {
          responsive.lastScreen[lastScreenId] = responsive.lastScreen[lastScreenId] || {};
          responsive.lastScreen[lastScreenId].name = responsive.lastScreen[lastScreenId].name || {};
          responsive.lastScreen[lastScreenId].name.width = currentScreenName;

          return false;
        }

        let isDifferentScreen = responsive.lastScreen[lastScreenId].name.width != currentScreenName;
        responsive.lastScreen[lastScreenId].name.width  = currentScreenName;

        return isDifferentScreen;
      }
    }
  },
  waiAria : {
    specialHtmlTagsCssSelector : 'input, button, a',
    init : () => {
      setTimeout(() => {
        responsive.waiAria.hideOnDevice.check('hide');
        responsive.waiAria.hideOnDevice.check('show');
      }, 1000);

      $(window).resize(() => {
        if (!responsive.changeScreen.name.accordingToWidth('wai-responsive')) {
          return;
        }

        responsive.waiAria.hideOnDevice.check('hide');
        responsive.waiAria.hideOnDevice.check('show');
      });
    },
    hideOnDevice : {
      selector : '[class*=hide-], [class*=show-]',
      check : (showState) => {
        /*
        * This function will only works on element that has only ONE class 'hide' and/or ONE class 'show'
        * */
        showState = showState || false;
        showState = showState == 'hide' || showState == 'show' ? showState : 'hide';

        $(responsive.waiAria.hideOnDevice.selector).data('showState', showState);

        $(responsive.waiAria.hideOnDevice.selector).each((index, elementHtmlTag) => {
          let showState = $(elementHtmlTag).data('showState');
          let regex = new RegExp('(^|.*\\s)' + showState + '\\-([^\\s]+)+.*');

          if (!regex.test($(elementHtmlTag).attr('class'))) {
            return;
          }

          let changeShowStatusScreen = $(elementHtmlTag).attr('class').replace(regex, '$2');
          let changeShowStatusScreenOnly = changeShowStatusScreen.replace(/-only/, '');

          if (responsive.screens[changeShowStatusScreen]) {
            if (responsive.getCurrentScreen.value.width() >= responsive.screens[changeShowStatusScreen]['minWidth']) {
              responsive.waiAria.hideOnDevice.hide($(elementHtmlTag), showState != 'hide');
            }
            else if (responsive.getCurrentScreen.value.width() < responsive.screens[changeShowStatusScreenOnly]['minWidth']) {
              responsive.waiAria.hideOnDevice.hide($(elementHtmlTag), showState == 'hide');
            }
          }
          else if (
            responsive.screens[changeShowStatusScreenOnly]
            && responsive.getCurrentScreen.value.width() >= responsive.screens[changeShowStatusScreenOnly]['minWidth']
            && responsive.getCurrentScreen.value.width() <= responsive.screens[changeShowStatusScreenOnly]['maxWidth']
          ) {
            responsive.waiAria.hideOnDevice.hide($(elementHtmlTag), showState != 'hide');
          }
          else if (
            responsive.screens[changeShowStatusScreen]
            || responsive.screens[changeShowStatusScreenOnly]
          ) {
            responsive.waiAria.hideOnDevice.hide($(elementHtmlTag), showState == 'hide');
          }
        });
      },
      hide : (elementHtmlTag, show) => {
        show = show || false;

        if (show && elementHtmlTag.hasClass('hidden-by-controller')) {
          /*
          * Keep it hidden
          * */
          return;
        }
        else if (!show && !elementHtmlTag.hasClass('wia-lure')) {
          /*
          * Create a lure to replace the hidden item
          * That avoids WIA issue when element is duplicated
          * */
          let lure = document.createElement('DIV');
          /* Keep the class for passing again on the element */
          lure.className = elementHtmlTag.attr('class') + ' wia-lure';
          /* ADD lure in DOM */
          elementHtmlTag.after(lure);
          /* DEL potential association between the element and other */
          if (elementHtmlTag.attr('aria-controls')) {
            $('#' + elementHtmlTag.attr('aria-controls')).removeAttr('aria-labelledby');
          }
          /* Save the element + DEL element from DOM */
          $(lure).data('realElementHtmlTag', elementHtmlTag.detach());

          responsive.waiAria.hide($(lure), show, '1');
          responsive.waiAria.hide(elementHtmlTag, show, '1');

        }
        else if (show && elementHtmlTag.data('realElementHtmlTag')) {
          /*
          * Replace the lure by element
          * */
          /* Switch for sense */
          let lure = elementHtmlTag;
          /* Recover the real element */
          elementHtmlTag = elementHtmlTag.data('realElementHtmlTag');
          /* ADD element in DOM */
          lure.after(elementHtmlTag);
          /* DEL lure from DOM */
          lure.detach();
          /* Recover potential association between element and other */
          if (elementHtmlTag.attr('aria-controls')) {
            $('#' + elementHtmlTag.attr('aria-controls')).attr('aria-labelledby', elementHtmlTag.attr('id'));
          }

          responsive.waiAria.hide(elementHtmlTag, show, '1');
        }
      }
    },
    hide : (elementHtmlTag, show, addClass) => {
      show = show || false;
      addClass = addClass || '12';

      elementHtmlTag.attr('aria-hidden', !show);

      if (show) {
        elementHtmlTag.find(responsive.waiAria.specialHtmlTagsCssSelector)
          .attr('tabIndex', 0);
        elementHtmlTag.find('.hidden-by-controller').find(responsive.waiAria.specialHtmlTagsCssSelector)
          .attr('tabIndex', -1);

        if (/1/.test(addClass)) {
          elementHtmlTag.removeClass('visibility-hidden');
          elementHtmlTag.addClass('visibility-shown');
        }

        if (/2/.test(addClass)) {
          elementHtmlTag.removeClass('hidden-by-controller');
        }
      }
      else {
        elementHtmlTag.find(responsive.waiAria.specialHtmlTagsCssSelector).attr('tabIndex', -1);

        if (/1/.test(addClass)) {
          elementHtmlTag.removeClass('visibility-shown');
          elementHtmlTag.addClass('visibility-hidden');
        }

        if (/2/.test(addClass)) {
          elementHtmlTag.addClass('hidden-by-controller');
        }
      }
    },
    active : (elementHtmlTag, active) => {
      active = active || false;

      elementHtmlTag
        .attr('disabled', !active)
        .addClass(active ? 'active' : 'inactive')
        .removeClass(active ? 'inactive' : 'active');
    }
  }
};

export default responsive;
